export const socials = {
  TWITTER_URL: 'https://twitter.com/GhosteTheDev',
  LINKEDIN_URL: 'https://www.linkedin.com/in/mitchelvanbever/',
  GITHUB_URL: 'https://github.com/mitchelvanbever',
};

export const generalLinks = {
  AMS_URL: 'https://storyofams.com/',
};
